import widgetConfigApi from '../components/api/widgetConfigApi'
import formUtils from './formUtils'
import alertUtils from './alertUtils'

/**
 *  配置的工具类
 */
export default class widgetConfigUtils {
  /**
   *  查询字典类型列表
   * @param id
   * @param name 字段类型名称
   * @param page 当前页数
   * @param limit 条数
   * @param dicType 数据字典 当前页数，已查询出条数 结果集
   */
  static queryDicTypeList(dicType) {
    if (dicType.isEnd) {
      dicType.loading = false
      return
    }
    if (formUtils.isNull(dicType.id)) {
      alertUtils.alertWarning('查询字典类型列表ID不能为空', true)
      dicType.loading = false
      return
    }

    widgetConfigApi
      .getDicTypeList(dicType.id, dicType.name, dicType.page, dicType.limit)
      .then(response => {
        const count = response.count // 总条数
        if (count > 0) {
          if (response.data != null && response.data.length > 0) {
            dicType.list.push(...response.data)
          }
          if (count <= dicType.limit) {
            dicType.isEnd = true
          } else if (count <= dicType.list.length) {
            dicType.isEnd = true
          }
        } else {
          dicType.isEnd = true
        }
        dicType.loading = false
      })
      .catch(() => {
        alertUtils.alertError('字典类型列表查询错误', true)
        dicType.loading = false
      })
  }
}
